<script>
import baseMixin from '@mixins/baseMixin'
import OutstandingInvoiceAlert from '@/components/invoices/outstanding-invoice-alert.vue'
import TheDebugBar from '@components/dev/the-debug-bar.vue'
import TheNavDrawer from '@components/layout/the-nav-drawer.vue'
import navMixin from '@/mixins/navMixin'
import TheImpersonateBar from '@/components/impersonate/the-impersonate-bar.vue'
import ServiceStatusAlert from '@/components/app/service-status-alert.vue'

export default {
  components: {
    OutstandingInvoiceAlert,
    TheDebugBar,
    TheNavDrawer,
    TheImpersonateBar,
    ServiceStatusAlert,
  },
  mixins: [baseMixin, navMixin],
  props: {
    noGutters: {
      type: Boolean,
    },
  },
  data() {
    return {
      drawer: null,
    }
  },
  computed: {
    compXAxisPadding() {
      switch (true) {
        case this.isLarge:
        case this.isMedium:
          return this.navItemPadding()
        case this.isSmallOrLower:
          return 'px-2'
        default:
          return ''
      }
    },
    showOutstandingInvoiceAlert() {
      // check if any nav item is "nav-bookings" AND active
      return !this.navItems.some(
        ({ key, to }) => key === 'nav-bookings' && this.isActiveNavItem(to)
      )
    },
    isNavBookingsActive() {
      for (const { key, to } of this.navItems) {
        if (key === 'nav-bookings' && this.isActiveNavItem(to)) {
          return true
        }
      }
      return false
    },
  },
  mounted() {
    // Init drawer state on mobile to be closed
    this.drawer = !this.isMobileViewPort
  },
  methods: {
    navItemPadding() {
      let padding = this.noGutters ? '' : 'px-8'

      for (const { key, to } of this.navItems) {
        // special override for nav-bookings when active
        if (key === 'nav-bookings' && this.isActiveNavItem(to)) {
          padding = 'px-0'
        }
      }
      return padding
    },
  },
}
</script>

<template>
  <v-app id="client-login">
    <TheDebugBar />
    <TheImpersonateBar />
    <TheNavDrawer :drawer="drawer" @setDrawerState="drawer = $event" />
    <v-main
      class="mainDiv"
      :class="[isNavBookingsActive ? 'booking-main-container' : '']"
    >
      <ServiceStatusAlert />
      <v-container
        :class="[
          'fill-height',
          isNavBookingsActive ? 'fluid-container px-0' : '',
          noGutters ? 'ma-0 pa-0' : '',
          compXAxisPadding,
        ]"
        :fluid="isLargeOrLower || noGutters"
        style="margin-bottom: 100px"
      >
        <v-layout>
          <v-flex xs12 sm12 md12>
            <OutstandingInvoiceAlert v-if="showOutstandingInvoiceAlert" />
            <slot />
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
.booking-main-container {
  background: $color-white !important;
}
.fluid-container {
  min-width: 100%;
}
</style>
